import React from 'react';
import Col from './col'

export default class Row extends React.Component {
  
  render() {
    var cols = this.props.el.content || []
    if (Object.prototype.toString.call(cols) !== '[object Array]') cols = [];
    if (cols.length > 0) cols = cols.filter(el => el && el.type == "col")
    if (cols.length == 0) cols.push({type: "col"})
    this.props.el.content = cols
    let editMode = this.props.mode == "edit"
    let selected = editMode && this.props.root.state.selected == this
    var showRemove = false
    if (editMode && (cols.length > 0)) {
      for (var i = 0; i < cols.length; i++) {
        if (this.props.root.state.selectedEl == cols[i] 
          && (cols.length > 1 || cols[i].content.type != 'new')) {
          showRemove = true;
          break;
        }
      }
    }

    return (
      <div 
        class={"row news-row news-grid mode-"+this.props.mode+(selected ? " selected" : "")}
        onClick={editMode ? e => this.props.onSelect(e,this.props.el,this) : undefined}
      >
        {cols.map((el,e) => {
          return (
            <Col
              key={e}
              index={e}
              el={el}
              mode={this.props.mode}
              root={this.props.root}
              onSelect={this.props.onSelect}
              iframes={this.props.iframes}
            />
          )
        })}
        {editMode &&
          <div class="col-sm news-add-col text-center p-1" >
            <div>
              <button class="btn btn-sm warning btn-grid" 
                      onClick={e => this.props.root.addCol(e, this.props.el, this)}
              >+</button>
            </div>
            {showRemove && 
            <div>
              <button class="btn btn-sm danger btn-grid mt-2" 
                      onClick={e => this.props.root.removeCol(e, this.props.el, this)}
              >-</button>
            </div>
            }
          </div>
        }        
      </div>          
    )     
  }

}